export const filterData = [
  {
    id: "1",
    title: "All", // course category
  },
  {
    id: "2",
    title: "Development", // course category
  },
  {
    id: "3",
    title: "Business", // course category
  },
  {
    id: "4",
    title: "Design", // course category
  },
  {
    id: "5",
    title: "Lifestyle", // course category
  },
];

// All the filtered button data
// This filterData contains the details of the all the buttons based on the course category
// The filterData array will be used to show the buttons in the Filter component

export const apiUrl = "https://codehelp-apis.vercel.app/api/get-top-courses";
// from where I can get the course details
